var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.form
    ? _c(
        "div",
        {
          class:
            (_vm.inFrame ? "outer-wrapper-in-frame" : "outer-wrapper") +
            " row-format centered",
          style:
            "font-family: " +
            _vm.font +
            "; --background-color: " +
            _vm.form.accentColor
        },
        [
          _vm.form
            ? _c(
                "v-container",
                {
                  class:
                    "" +
                    (_vm.inFrame ? "main-wrapper-in-frame" : "main-wrapper")
                },
                [
                  _vm.form.showLogo && _vm.form.accountLogo
                    ? _c(
                        "v-row",
                        { staticClass: "form-logo-row" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("img", {
                              staticClass: "form-logo",
                              attrs: { src: _vm.form.accountLogo }
                            })
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.complete
                    ? _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              { staticClass: "form-fields" },
                              [
                                _c("renderer", {
                                  ref: "renderer",
                                  attrs: { schema: _vm.form.schema },
                                  on: { input: _vm.handleResult }
                                })
                              ],
                              1
                            )
                          ]),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              { staticClass: "form-footer" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "form-submit",
                                    attrs: {
                                      color: _vm.form.accentColor,
                                      elevation: "0"
                                    },
                                    on: { click: _vm.saveForm }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        style:
                                          "font-weight: 600; color: " +
                                          _vm.form.buttonText +
                                          "!important; text-transform:none!important"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("global.submit")))]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-recaptcha font-gray_70"
                                  },
                                  [
                                    _vm._v(
                                      " This page is protected by reCAPTCHA and the Google "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "https://policies.google.com/privacy"
                                        }
                                      },
                                      [_vm._v("Privacy Policy")]
                                    ),
                                    _vm._v(" and "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "https://policies.google.com/terms"
                                        }
                                      },
                                      [_vm._v("Terms of Service")]
                                    ),
                                    _vm._v(" apply. ")
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _vm._v(_vm._s(_vm.$t("discovery.complete")))
                          ])
                        ],
                        1
                      )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-snackbar",
            {
              attrs: { top: "", color: "gray_80", timeout: 5000 },
              scopedSlots: _vm._u(
                [
                  {
                    key: "action",
                    fn: function(ref) {
                      var attrs = ref.attrs
                      return [
                        _c(
                          "v-btn",
                          _vm._b(
                            {
                              attrs: { color: "error", text: "" },
                              on: {
                                click: function($event) {
                                  _vm.showError = false
                                }
                              }
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          [_vm._v(" OK ")]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                441339782
              ),
              model: {
                value: _vm.showError,
                callback: function($$v) {
                  _vm.showError = $$v
                },
                expression: "showError"
              }
            },
            [_vm._v(" " + _vm._s(_vm.errorText) + " ")]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }